import t from 'tcomb';
import template from 'lodash/string/template';

const Rule = t.struct({
  name: t.Str,
  args: t.maybe(t.Arr)
}, 'Rule');

(function() {

  var localizers = {};

  Rule.add_localizer = function(name, localizer) {
    t.assert(!localizers.hasOwnProperty(name));
    localizers[name] = localizer;
    return Rule;
  };

  Rule.get_localizer = function(name) {
    return localizers[name];
  };

})();


function pluralize(bundle, opts) {
  t.assert(t.union([t.Str, t.Obj]).is(bundle));
  t.assert(t.Obj.is(opts));

  var src = t.Obj.is(bundle) ?
    opts.count === 0 ? bundle.zero :
    opts.count === 1 ? bundle.one :
    bundle.other :
    bundle;
  return template(src)(opts);
}


Rule
  .add_localizer('required', function(args, locale) {
    return Rule.bundle(locale).required;
  })
  .add_localizer('format', function(args, locale) {
    return Rule.bundle(locale)[args[0]];
  })
  .add_localizer('max_length', function(args, locale) {
    var max_length = args[0];
    return pluralize(Rule.bundle(locale).max_length, {
      arg: locale.format_integer(max_length),
      count: max_length
    });
  })
  .add_localizer('min_length', function(args, locale) {
    var min_length = args[0];
    return pluralize(Rule.bundle(locale).min_length, {
      arg: locale.format_integer(min_length),
      count: min_length
    });
  })
  .add_localizer('max', function(args, locale) {
    var max = args[0];
    return template(Rule.bundle(locale).max)({
      arg: locale.format_integer(max)
    });
  })
  .add_localizer('min', function(args, locale) {
    var min = args[0];
    return template(Rule.bundle(locale).min)({
      arg: locale.format_integer(min)
    });
  })
  .add_localizer('number', function(args, locale) {
    return Rule.bundle(locale).number;
  })
  .add_localizer('date', function(args, locale) {
    return Rule.bundle(locale).date;
  })
  .add_localizer('integer', function(args, locale) {
    return Rule.bundle(locale).integer;
  })
  .add_localizer('any', function(args, locale) {
    return Rule.bundle(locale).any;
  })
  .add_localizer('min_items', function(args, locale) {
    var min_items = args[0];
    return pluralize(Rule.bundle(locale).min_items, {
      count: min_items,
      arg: min_items
    });
  })
  .add_localizer('mobile_number_not_allowed', function(args, locale) {
    var prefix = args[0];
    return template(Rule.bundle(locale).mobile_number_not_allowed)({
      arg: prefix
    });
  })
  .add_localizer('duplicated_routing_option', function(args, locale) {
    return Rule.bundle(locale).duplicated_routing_option;
  })
  .add_localizer('priority_is_integer', function(args, locale) {
    return Rule.bundle(locale).priority_is_integer;
  })
  .add_localizer('duplicated_option', function(args, locale) {
    return Rule.bundle(locale).duplicated_option;
  })
  .add_localizer('is_ranking', function(args, locale) {
    return Rule.bundle(locale).is_ranking;
  });


Rule.prototype.localize = function(locale) {
  //assert(Locale.is(locale)); //fixme
  return Rule.get_localizer(this.name)(this.args, locale);
};

Rule.bundle = function(locale) {
  return locale.language_bundle().validation;
};

export default Rule;


/*
function Rule(name, args) {
  args = args || [];
  assert(Str.is(name));
  assert(Arr.is(args));
  this.name = name;
  this.args = args;
  return freeze(this);
}

Rule.is = function(x) {
  return x instanceof Rule;
};

Rule.of = function(x) {
  assert(Obj.is(x));
  return new Rule(
    Str.of(x.name),
    Arr.of(x.args)
  );
};
*/


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Rule.js
 **/